module.exports = __webpack_public_path__ + "img/T1A_rc_25.d006c939.png";